export default {
    "Data Record" : "വിവര രേഖ", 
    "My storage" : "എന്റെ ശേഖരണം",
    "Upgrade" : "നവീകരിക്കുക",
    "Data Size" :" വിവരത്തിന്റെ വലിപ്പം",
    "Folders" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടം",
    "Your file is getting upload": "നിങ്ങളുടെ ഫയലുകൾ അപ് ലോഡു ചെയ്യുന്നു",
    "Folder Name": " വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടത്തിന്റെ പേര് ", 
    "Files": "ഫയലുകൾ",
    "Rename Folder" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടത്തിന്റെ പേര് മാറ്റുക",
    "Move Folder" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടം നീക്കുക അല്ലെങ്കിൽ ചലിപ്പിക്കുക",
    "Delete Folder": "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടം ഇല്ലാതാക്കുക",
    "Upload":  "അപ് ലോഡ് ചെയ്യുക",
    "Create Folder" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടം സൃഷ്ടിക്കുക",
    "Uploading" : "അപ്‌ലോഡ് ചെയ്യുന്നു",
    "Cancel Uploading" : " അപ്‌ലോഡ് ചെയുന്നത് റദ്ദാക്കുക",
    "Are you sure want to cancel ?" : "ഉറപ്പായും നിങ്ങൾക്ക് ഇത് റദ്ദാക്കണമോ? ", 
    "Yes" : "അതെ",
    "No" : "അല്ല",
    "Are you sure want to delete ?" :  "ഉറപ്പായും നിങ്ങൾക്ക് ഇത് ഇല്ലാതാക്കണമോ? ",
    "Cancel" : "റദ്ദാക്കുക",
    "Delete" : "ഇല്ലാതാക്കുക",
    "Rename Folder/File" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടത്തിന്റെയോ അല്ലെങ്കിൽ ഫയലിന്റെയോ പേര് മാറ്റാം",
    "Folder Name / File Name" : "വിവരങ്ങൾ സൂക്ഷിക്കുന്ന ഇടത്തിന്റെ പേര് അല്ലെങ്കിൽ ഫയലിന്റെ പേര്",
    "Save" : "സൂക്ഷിക്കുക/ സംരക്ഷിക്കുക",
    "Move file" : "ഫയൽ നീക്കുക അല്ലെങ്കിൽ ചലിപ്പിക്കുക",
    "Move" : "നീക്കുക അല്ലെങ്കിൽ ചലിപ്പിക്കുക",
    "Share" : "പങ്കിടുക",
    "Rename": "പേര് മാറ്റുക",
    "Delete"  : "ഇല്ലാതാക്കുക",
    "Download" : "പകർത്തുക അല്ലെങ്കിൽ ഡൗൺലോഡ് ചെയ്യുക",
    "No data found": "ഒരു വിവരങ്ങളും അല്ലെങ്കിൽ രേഖകളും കണ്ടെത്താനായില്ല",
     "Search" : "തിരയുക",
    "Upload successfully" : "വിജയകരമായി അപ്‌ലോഡ് ചെയ്തിരിക്കുന്നു",
    "You can share one file at a time" : "ദയവായി നിങ്ങൾ ഒരു സമയം ഒരു ഫയൽ പങ്കിടുക",
    "Choose your folder and click on move here" : " നിങ്ങൾക്കു വേണ്ട ഫയൽ തിരഞ്ഞെടുത്ത ശേഷം ഫയൽ ചലിപ്പിക്കാൻ വേണ്ടി നീക്കുക അല്ലെങ്കിൽ ചലിപ്പിക്കുക അമർത്തുക",
    "You can download one file at time" : "നിങ്ങൾക്ക് ഒരു സമയം ഒരു ഫയൽ പകർത്താനാവുന്നതാണ് അല്ലെങ്കിൽ ഡൗൺലോഡ് ചെയ്യാവുന്നതാണ്",
    "you can rename one file at a time" : "നിങ്ങൾക്ക് ഒരു സമയം ഒരു ഫയലിന്റെ പേര് മാറ്റാവുന്നതാണ്",
    "Rename successfull" : "വിജയകരമായി പേര് മാറ്റിയിരിക്കുന്നു",
    "File Deleted Successfully": "വിജയകരമായി ഫയൽ ഇല്ലാതാക്കിയിരിക്കുന്നു",
    "Load More" : "കുറേക്കൂടി ലോഡ് ചെയ്യണം",
    "No more Data" : "കൂടുതൽ വിവരങ്ങൾ ഒന്നും ഇല്ല",
    "Insufficient Memory": "आपके पास पर्याप्त जगह नहीं है"

    }